import React, { useState } from 'react';

export const BreadcrumbContext = React.createContext(null);

function BreadcrumbContextProvider(props) {
    const [ctx, setCts] = useState({
        type: null,
        setType(type) {
            setCts(prev => {
                return {
                    ...prev,
                    type
                };
            });
        }
    });

    return (
        <BreadcrumbContext.Provider value={ctx}>
            {props.children}
        </BreadcrumbContext.Provider>
    );
}

export default BreadcrumbContextProvider;